export enum LoginFormField {
  Email = 'email',
  Password = 'password',
  Remember = 'remember',
}
